var _ellipse, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgreeText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5222 12.0168V23.88C36.5222 24.6547 35.9396 25.2891 35.1814 25.3442C31.9884 25.5762 25.3364 25.9206 20.9513 25.2014C18.8688 24.8599 15.5436 24.0853 13.609 23.6194C12.9445 23.4594 12.4778 22.8634 12.4778 22.1744V15.9363C12.4778 15.1079 13.1494 14.4363 13.9778 14.4363H16.53C17.5185 14.4363 18.4142 13.8538 18.8151 12.9503L22.9777 3.56935C23.2182 3.02721 23.7556 2.67773 24.3488 2.67773H25.6986C26.527 2.67773 27.1986 3.34931 27.1986 4.17773V8.01677C27.1986 9.39748 28.3179 10.5168 29.6986 10.5168H35.0222C35.8507 10.5168 36.5222 11.1883 36.5222 12.0168Z",
    fill: "white",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3571 20.3501C15.6849 20.3501 16.98 18.6233 16.98 15.5421C16.98 12.4525 15.6764 10.7341 13.3147 10.7341C11.9773 10.7341 10.9785 11.4113 10.5383 12.5541H10.4706V8H7V20.2147H10.4706V18.5979H10.5383C10.97 19.6899 11.9858 20.3501 13.3571 20.3501ZM11.9434 13.409C12.8407 13.409 13.4248 14.247 13.4248 15.5421C13.4248 16.8457 12.8492 17.6753 11.9434 17.6753C11.0292 17.6753 10.4621 16.8711 10.4536 15.5506C10.4621 14.247 11.0377 13.409 11.9434 13.409Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreeText);
export default __webpack_public_path__ + "static/media/AgreeText.578fb180cfc03073f27021cb704c3b89.svg";
export { ForwardRef as ReactComponent };